<template>
  <div class="cookie__button">
    <button
      class="cookie__button-label"
      tabindex="0"
      role="button"
      aria-pressed="true"
      @click="accept"
      @mouseenter="cursorToScroll()"
      @mouseleave="cursorToClose()"
    >
      {{ label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'CookieButton',

  props: {
    label: {
      type: String,
      required: true,
    },
  },

  methods: {
    accept() {
      localStorage.setItem('cookie:accepted', '1');
      this.$parent.$emit('cookie-accepted');
    },

    cursorToScroll() {
      this.$eventHub.$emit('soundInteraction');
      this.$eventHub.$emit('cursorToZoom');
    },

    cursorToClose() {
      if (!this.$store.state.scrollIsLocked) {
        this.$eventHub.$emit('cursorToClose');
      } else {
        this.$eventHub.$emit('cursorToScroll');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cookie__button button {
  position: relative;
  cursor: pointer;

  padding: 0;
  border: 0;
  background-color: transparent;
  font-size: 16px;
  font-family: $font-family-base;
  color: #4F4F4F;

  &::before {
    content: '';

    position: absolute;
    bottom: -2px;
    left: 0;
    width: 100%;
    height: 1px;

    background-color: #4F4F4F;
    transform-origin: 0% 50%;
    transition: transform 0.5s $inOutQuint;
  }

  &:hover::before {
    transform: scaleX(0);
  }
}
</style>
